import { CRITERIA_STATUS } from './constants'
import { isQualifyingTriggerReason } from './normalizeTriggerReasonId'

const getKbaCriteriasList = (species) => {
  if (Array.isArray(species?.kbaCriterias)) {
    return species.kbaCriterias
  }

  return []
}

const isLegacySpecies = (species) => {
  return species?.legacySpecies === true || species?.LegacySpecies === true
}

export const getCriteriaStatus = (species) => {
  const kbaCriterias = getKbaCriteriasList(species)

  if (!isQualifyingTriggerReason(species?.triggerReasonId)) {
    return CRITERIA_STATUS.DISQUALIFIED_TRIGGER
  }

  if (kbaCriterias.length > 0) {
    return CRITERIA_STATUS.QUALIFYING_TRIGGER
  }

  if (isLegacySpecies(species)) {
    return CRITERIA_STATUS.LEGACY_TRIGGER
  }

  return CRITERIA_STATUS.NON_QUALIFYING
}

export const getCriteriaStatusLabelId = (criteriaStatus) => {
  switch (criteriaStatus) {
    case CRITERIA_STATUS.QUALIFYING_TRIGGER:
      return 'criteriaStatusQualifyingTrigger'
    case CRITERIA_STATUS.DISQUALIFIED_TRIGGER:
      return 'criteriaStatusDisqualifiedTrigger'
    case CRITERIA_STATUS.LEGACY_TRIGGER:
      return 'criteriaStatusLegacyTrigger'
    case CRITERIA_STATUS.NON_QUALIFYING:
      return 'criteriaStatusNonQualifying'
    default:
      return 'criteriaStatus'
  }
}
